import { useEffect } from 'react';
import { useAppSelector } from '@/shared/hooks-tmp/reduxToolkitHooks';
import { useProducts } from '@/entities/pricing';
import { getEnterpriseSubscriptionState, useBalanceStore } from '@/entities/user/balance';

export const useBalance = () => {
  const user = useAppSelector((state) => state.user);
  const { products } = useProducts();

  const setBalance = useBalanceStore((state) => state.setBalance);
  const updateBalance = useBalanceStore((state) => state.updateBalance);

  useEffect(() => {
    if (user) {
      setBalance(user);
    }
  }, [user, setBalance]);

  const userPlanId = user?.subscription?.plan.product_id;
  const subscriptionStatus = user?.subscription?.status;

  useEffect(() => {
    if (products) {
      const enterpriseSubscriptionState = getEnterpriseSubscriptionState(products.plan, userPlanId, subscriptionStatus);

      const canBuyMinutes = products.credit.length > 0 && products.credit[0].prices.length > 0;

      const hasArchivedSubscription = Boolean(products.plan.find(({ id }) => id === userPlanId)?.is_archived);

      updateBalance({
        ...enterpriseSubscriptionState,
        hasArchivedSubscription,
        canBuyMinutes,
      });
    }
  }, [products, userPlanId, subscriptionStatus, updateBalance]);
};
